import React from 'react';
import { StaticPage } from '../StaticPage';

export const ContactPage: React.FC = () => (
  <StaticPage titleKey="static.contact">
    <p>
      Brauchst Du Hilfe?<br />
      Hast Du einen Feature-Wunsch?<br />
      Ein geschäftliches Angebot?<br />
      Wir sind ganz Ohr!
    </p>

    <p>
      <strong>Event Partner Austria Kulturservice</strong>
      <br />
      Kwizdastrasse 11/9
      <br />
      2100 Korneuburg
      <br />
      Österreich
    </p>
    <p>
      Tel.:{' '}
      <a href="tel:+43800880288">0800 88 02 88</a>
      {' '}(werktags, Montag – Freitag: 9:30 – 13:30)
    </p>
    <p>
      E-Mail:{' '}
      <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
    </p>
  </StaticPage>
);
